import { Icon } from '../icon/icon'
import { getIconName } from '../icon/icon.helper'
import { cn } from '~/utils/misc'

interface Platform {
	name: string
	url: string
	icon: string
}

interface SocialLinksProps {
	size?: 'sm' | 'md' | 'lg'
}

export default function SocialLinks({ size = 'md' }: SocialLinksProps) {
	const socialPlatforms: Platform[] = [
		{
			name: 'Facebook',
			url: 'https://www.facebook.com/eventlyse',
			icon: 'facebook',
		},
		{
			name: 'Instagram',
			url: 'https://www.instagram.com/evently_se',
			icon: 'instagram',
		},
		{
			name: 'Tiktok',
			url: 'https://www.tiktok.com/@eventlyse',
			icon: 'tiktok',
		},
		{
			name: 'Linkedin',
			url: 'https://www.linkedin.com/company/evently-ab',
			icon: 'linkedin',
		},
	]

	// Define size classes
	const containerSizeClasses = {
		sm: 'gap-2',
		md: 'gap-4',
		lg: 'gap-6',
	}

	const iconSizeClasses = {
		sm: 'h-8 w-8',
		md: 'h-10 w-10',
		lg: 'h-12 w-12',
	}

	return (
		<div className={cn('flex', containerSizeClasses[size])}>
			{socialPlatforms.map(platform => (
				<a
					key={platform.name}
					href={platform.url}
					target="_blank"
					rel="noopener noreferrer"
					aria-label={platform.name}
					title={platform.name}
					className={cn(
						'group flex items-center justify-center rounded-full border border-secondary/40 bg-secondary/10 transition-all hover:border-secondary hover:bg-secondary/20 hover:shadow-[0_0_10px_rgba(var(--color-secondary-rgb),0.3)]',
						iconSizeClasses[size],
					)}
				>
					<Icon
						name={getIconName(platform.icon)}
						className="transition-transform group-hover:scale-110"
						size={size}
						aria-hidden="true"
					/>
				</a>
			))}
		</div>
	)
}
